import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import FieldDefault from 'components/field-default';

const WeekOfMonthSelector = ({ value, onChange }) => {
    const { t } = useTranslation('recurring');

    const handleBlur = value => {
        if (isNaN(value)) {
            value = 1;
        } else {
            value = Number(value);
        }

        if (value > 5) {
            value = 5;
        }

        onChange(value);
    }

    useEffect(() => {
        if (!('weekOfMonth' in value)) {
            onChange(1);
        }
    }, [value, onChange]);

    return (
        <div className="resource-repeat-row">
            <div className="row-label">
                { t('Week') }
            </div>

            <div className="row-value">
                <div className="row-input">
                    <FieldDefault
                        small={true}
                        type="number"
                        min="-6"
                        max="6"
                        value={value.weekOfMonth}
                        onBlur={handleBlur}
                        onChange={onChange}
                    />
                </div>

                {/*<div className="row-input">
                    <Checkbox dark={true}>From last</Checkbox>
                </div>*/}

                <small className="input-helper">
                    ({ t('weekOfMonthHelper') })
                </small>
            </div>
        </div>
    );
}

export default WeekOfMonthSelector
